import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { AutomationId } from 'utils/automationUtil'
import {
  StyledContainer,
  StyledContentContainer,
  StyledHeaderContainer,
  StyledHeaderLeft,
  StyledHeaderRight,
  StyledIconContainer,
  StyledActionContainer
} from './index.css'

const StyledContentInHeader = styled(StyledHeaderLeft)`
  line-height: ${sys.typescale[14].lineHeight};
  font-size: ${sys.typescale[14].size};
`

type CompactSoundbiteNoHeaderFrameProps = {
  dateItem?: React.ReactNode
  domainIcon?: React.ReactElement
  postContent?: React.ReactNode
  actionItems?: React.ReactNode
  avatar?: React.ReactNode
  photoUserTagContent?: React.ReactNode
  serialNumber: number
}

const CompactSoundbiteNoHeaderFrame = ({
  dateItem,
  domainIcon,
  postContent,
  actionItems,
  avatar,
  photoUserTagContent,
  serialNumber
}: CompactSoundbiteNoHeaderFrameProps) => {
  const theme = useDisplayTheme() as Theme

  return (
    <StyledContainer
      mode={theme}
      data-testid={`${AutomationId.compactSoundbiteDefaultFrame.post}-${serialNumber}`}>
      {avatar}
      <StyledContentContainer>
        <StyledHeaderContainer>
          <StyledContentInHeader>{postContent}</StyledContentInHeader>
          <StyledHeaderRight mode={theme}>
            {dateItem}
            <StyledIconContainer>{domainIcon}</StyledIconContainer>
          </StyledHeaderRight>
        </StyledHeaderContainer>
        {photoUserTagContent}
        <StyledActionContainer>{actionItems}</StyledActionContainer>
      </StyledContentContainer>
    </StyledContainer>
  )
}

export default CompactSoundbiteNoHeaderFrame
